import React, { useState } from 'react';
import { login } from '../core/auth';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSubmitting(true);

        try {
            await login(email, password);
        } catch (err) {
            setError('Invalid email or password.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-slate-900" data-theme="sentinel">
            <form onSubmit={handleSubmit} className="w-full max-w-[340px] bg-base-100 rounded-lg p-6 shadow-xl">
                <div className="flex items-center gap-2 justify-center mb-6">
                    <span className="w-7 h-7 rounded bg-red-600 flex items-center justify-center text-white text-xs font-bold">
                        RS
                    </span>
                    <p className="font-semibold text-base">Red Sentinel Admin</p>
                </div>

                <label className="block">
                    <span className="label-text text-xs font-semibold">Email</span>
                    <input
                        type="email"
                        autoComplete="username"
                        className="input input-bordered input-sm w-full mt-1 mb-3"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </label>

                <label className="block">
                    <span className="label-text text-xs font-semibold">Password</span>
                    <input
                        type="password"
                        autoComplete="current-password"
                        className="input input-bordered input-sm w-full mt-1 mb-3"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </label>

                {error && <p className="text-error text-xs mb-3">{error}</p>}

                <button
                    type="submit"
                    disabled={submitting}
                    className="btn btn-primary btn-sm w-full"
                >
                    {submitting ? 'Signing in…' : 'Sign in'}
                </button>
            </form>
        </div>
    );
};

export default Login;
